import React, { useRef, useEffect, useState } from "react";
import "../../Styles/Map.css";
import "../../Styles/ReIntro.css";
import "../../Styles/ReMap.css";
import "../../Styles/Legend.css";
import Legend from "./Legend";
import Chart from "./Chart";
import mapboxgl from 'mapbox-gl';
import { world_religion } from "./WorldReligion";

mapboxgl.accessToken = 'pk.eyJ1IjoiZWRtYW4iLCJhIjoiY2syNWs1ajk3MGM2NjNua3gxYTNhdWpkOSJ9.ngu-SlVjhLdLBPyDFFsIBw';

const EastAsian = () => {
    const mapContainer = useRef(null);
    const map = useRef(null);
    const [lng, setLng] = useState(-70.9);
    const [lat, setLat] = useState(42.35);
    const [zoom, setZoom] = useState(1);
    const [firstReligion, setFirstReligion] = useState("...");
    const [secondReligion, setSecondReligion] = useState("...");
    const [province, setProvince] = useState("...");
    const [country, setCountry] = useState("...");
    const [numerical, setNumerical] = useState(null);
    const [year, setYear] = useState("...");
    const [dataSource, setDataSource] = useState("...");
    const [display, setDisplay] = useState("map");
    let hoveredStateId = null;

    useEffect(() => {
        if (map.current) return; // initialize map only once
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/light-v10',
            center: [lng, lat],
            zoom: zoom,
            maxZoom: 5
        });
        map.current.addControl(new mapboxgl.NavigationControl());
    }, []);

    useEffect(() => {
        map.current.on('load', () => {
            map.current.addSource('world_religion', {
                'type': 'vector',
                'url': 'mapbox://edman.BRI_Religion_MTS'
            });
            map.current.addLayer(world_religion, 'state-label');
            map.current.addLayer({
                'id': 'state-fills',
                'type': 'fill',
                'source': 'world_religion',
                'source-layer': 'BRI_Religion_Layer',
                'layout': {},
                'paint': {'fill-color': '#627BC1','fill-opacity': ['case',['boolean', ['feature-state', 'hover'], false],1,0]}
                }
            );
            map.current.addLayer({
                'id': 'hover-fills',
                'type': 'fill',
                'source': 'world_religion',
                'source-layer': 'BRI_Religion_Layer',
                'layout': {},
                'paint': {'fill-color': '#666666'}
                }
            );
        });

        map.current.on('mousemove', 'world_religion', (e) => {
            if(e.features.length>0){
                console.log(e.features[0])
            }
            
        });
        map.current.on('mousemove', 'state-fills', (e) => {
            if (e.features.length > 0) {
                if (hoveredStateId !== null) {
                    map.current.setFeatureState(
                    { source: 'world_religion', sourceLayer: 'BRI_Religion_Layer', id: hoveredStateId },
                    { hover: false }
                    );
                }
                hoveredStateId = e.features[0].id;
                map.current.setFeatureState(
                    { source: 'world_religion', sourceLayer: 'BRI_Religion_Layer', id: hoveredStateId },
                    { hover: true }
                );
                setFirstReligion(e.features[0].properties.HighRelig);
                setSecondReligion(e.features[0].properties.SecRelig);
                setProvince(e.features[0].properties.ProvName);
                setCountry(e.features[0].properties.Country);
                setNumerical(e.features[0].properties.Numerical);
                setYear(e.features[0].properties.Year);
                setDataSource(e.features[0].properties.DataSource);

            }
        });
        map.current.on('mouseleave', 'state-fills', () => {
            if (hoveredStateId !== null) {
            map.current.setFeatureState(
            { source: 'world_religion', sourceLayer: 'BRI_Religion_Layer', id: hoveredStateId },
            { hover: false }
            );
            }
            hoveredStateId = null;
            }
        );
        map.current.setRenderWorldCopies(false);
        map.current.flyTo({
          center: [100, 35],
          zoom: 2,
        });

        map.current.on('moveend', () => {
            const features = map.current.queryRenderedFeatures({
              layers: ['world_religion']
            });
        
            if (features) {
              renderListings(features);
        
              // Clear the input container
              // Store the current features in sn `airports` variable to
              // later use for filtering on `keyup`.
            }
          });

        map.current.on('load', () => {
          map.current.setFilter("world_religion", [
            "any",
            ["==", "HighRelig", "East Asian Religiosity"],
          ]);
          map.current.setFilter("state-fills", [
            "any",
            ["==", "HighRelig", "East Asian Religiosity"],
          ]);
          map.current.setFilter("hover-fills", false);
              })
    }, []);
    
    //useEffect(() => {
    //    map.current.on('idle', () => {
    //    map.current.setFilter('world_religion', ['==', 'HighRelig', 'East Asian Religiosity'])
    //    })
    //}, []);

    function renderListings(features) {
        const empty = document.createElement('p'); 
        const listingEl = document.getElementById('feature-listing');
        // Clear any existing listings
        listingEl.innerHTML = '';
        if (features.length) {
          for (const feature of features) {
            const itemLink = document.createElement('div');
            const label =feature.properties.ProvName;
            itemLink.textContent = label;
            itemLink.addEventListener('mouseover', () => {
                setFirstReligion(feature.properties.HighRelig);
                setSecondReligion(feature.properties.SecRelig);
                setProvince(feature.properties.ProvName);
                setCountry(feature.properties.Country);
                setNumerical(feature.properties.Numerical);
                setYear(feature.properties.Year);
                setDataSource(features.properties.DataSource);
                map.current.setFilter("hover-fills", [
                    "any",
                    ["==", "ProvName", feature.properties.ProvName],
                  ]);
            });
            listingEl.appendChild(itemLink);
          }
      
        } else if (features.length === 0) {
          empty.textContent = 'No results found';
          listingEl.appendChild(empty);
        } else {
          empty.textContent = 'Drag the map to populate results';
          listingEl.appendChild(empty);
      
          // remove features filter
          map.current.setFilter("world_religion", [
            "any",
            ["==", "HighRelig", "East Asian Religiosity"],
          ]);
          
        }
      }


    return (
        <div className="map">
            <div className="container">
                <div
                    className="container"
                    style={{ flexDirection: "row", alignItems: "center" }}
                >
                    <div className="religionIcon eastasianIcon"></div>
                    <h1 className="introTitle">EAST ASIAN RELIGIOSITY</h1>
                </div>
                <div className="introContent">
                    <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum dolor
                    quo labore numquam repellendus iusto omnis incidunt, aliquid provident
                    sunt repellat cum nihil adipisci doloremque saepe tenetur commodi,
                    recusandae velit.
                    </p>
                </div>
            </div>
        
            <div>
                {display==="map"&&(
                    <div className="displayButtons">
                        <button style={{backgroundColor:"grey"}} onClick={()=>{setDisplay("map");window.location.reload();}}>Mapping</button>
                        <button onClick={()=>setDisplay("chart")}>Chart Data</button>
                    </div>
                )}

                {display==="chart"&&(
                    <div className="displayButtons">
                        <button onClick={()=>{setDisplay("map");window.location.reload();}}>Mapping</button>
                        <button style={{backgroundColor:"grey"}} onClick={()=>setDisplay("chart")}>Chart Data</button>
                    </div>
                )}

                {display==="map" &&
                    <>
                        <div className="label" style={{display:"flex"}}>
                            <div>90</div>
                            <div>70</div>
                            <div>50</div>
                        </div>
                        <Legend sub="East Asian" map={map}/>
                        {/*<div className="legend">
                            <div className="subRe">
                                <div style={{ width:"100%", marginLeft:"40px", fontWeight:"600"}}>East Asian</div>
                            </div>
                            <div className="colorScales">
                            <span style={{backgroundColor:"#CC2900"}}
                                onMouseOver={()=>{map.current.setFilter("world_religion", ["all",["==", "HighRelig", "East Asian Religiosity"],[">=", "Numerical", 90],]);}}
                                onMouseLeave={()=>{map.current.setFilter("world_religion", ["all",["==", "HighRelig", "East Asian Religiosity"],]);}}
                            ></span>
                            <span style={{backgroundColor:"#FF3300"}}
                                onMouseOver={()=>{map.current.setFilter("world_religion", ["all",["==", "HighRelig", "East Asian Religiosity"],[">=", "Numerical", 70],["<", "Numerical", 90]]);}}
                                onMouseLeave={()=>{map.current.setFilter("world_religion", ["all",["==", "HighRelig", "East Asian Religiosity"],]);}}
                            ></span>
                            <span style={{backgroundColor:"#FF704D"}}
                                onMouseOver={()=>{map.current.setFilter("world_religion", ["all",["==", "HighRelig", "East Asian Religiosity"],[">=", "Numerical", 50],["<", "Numerical", 70]]);}}
                                onMouseLeave={()=>{map.current.setFilter("world_religion", ["all",["==", "HighRelig", "East Asian Religiosity"],]);}}
                            ></span>
                            <span style={{backgroundColor:"#FFC2B3"}}
                                onMouseOver={()=>{map.current.setFilter("world_religion", ["all",["==", "HighRelig", "East Asian Religiosity"],["<", "Numerical", 50],]);}}
                                onMouseLeave={()=>{map.current.setFilter("world_religion", ["all",["==", "HighRelig", "East Asian Religiosity"],]);}}
                            ></span>
                            </div>
                        </div>*/}
                        <div ref={mapContainer} className="map-container" />
                        <div id="feature-listing"></div>
                        <div className="infoDisplay">
                            <div><h3>Country:</h3> {country} </div>
                            <div><h3>Province:</h3> {province} </div>
                            <div><h3>First Religion:</h3> {firstReligion} {numerical}%</div>
                            <div><h3>Second Religion:</h3> {secondReligion||"..."}</div>
                            <div><h3>Year:</h3> {year}</div>
                            <div><h3>Data Source:</h3> {dataSource}</div>
                        </div>
                    </>
                    
                }
                {display==="chart" &&<Chart religion="East Asian Religiosity"/>}
            </div>

        </div>
    );
};

export default EastAsian;